import { useMemo } from 'react'

export const useMinimalLayout = () => {
  const minimalLayout = useMemo(() => {
    // Handle SSR
    if (typeof window === 'undefined') {
      return false
    }

    const ml =
      new URLSearchParams(window.location.search).get('minimal') === 'true'
    return ml
  }, [])

  return minimalLayout
}
